import React, { Component } from 'react';
import Styles from "../../styles/Styles";

export default class Footer extends Component {
  constructor(props) {
   super(props);

    this.state = {
    };
  }

  render() {

    return (
      <footer style={Styles.Style.bgColorSecondary} className="footer-secondary">
        <div className="row">
          <div className="mycol-6 text-center">
            <b>Contact</b>
          </div>
        </div>
        <div className="row">
          <div className="mycol-6">
            <div className="row">
              <div className="mycol-6 text-center">
                <b>Yohan BOVAR</b><br/>
                Président<br />
                yohan.bovar@mesavantagespara.com<br />
                Tel: 03 89 41 78 07<br />
              </div>
              <div className="mycol-6 text-center">
                <b>Elodie ARNOLD</b><br/>
                Chargée de Relation Clientèle<br />
                elodie.arnold@mesavantagespara.com<br />
                Tel: 03 89 41 78 07<br />
              </div>
            </div>
          </div>
          
          <div className="mycol-6 text-center">
            SAS MES AVANTAGES - Tous droits réservés
          </div>
        </div>
      </footer>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/SellingPage/Footer.js